import { QueryClient } from '@tanstack/react-query';

import { getAdmissionsQueryKey } from '../../admissions/use-get-admissions';
import { createEventGroupsKey } from '../use-get-admission-groups';
import { GET_EVENT_QUERY_KEY } from '../use-get-event';
import { createEventSectionsKey } from '../use-get-event-sections';

export const invalidateEventQueries = async (queryClient: QueryClient, eventId: string) => {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: getAdmissionsQueryKey(eventId) }),
    queryClient.invalidateQueries({ queryKey: createEventSectionsKey(eventId) }),
    queryClient.invalidateQueries({ queryKey: createEventGroupsKey(eventId) }),
    queryClient.invalidateQueries({ queryKey: [GET_EVENT_QUERY_KEY, eventId] }),
  ]);
};
